var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"personal-container"},[_c('Header'),_c('logo-header',{attrs:{"title":"个人中心"}}),_c('div',{staticClass:"personal-main"},[_c('router-view')],1),_c('div',{staticClass:"foot-container"},[_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }